/**
 * Public Tggl client-side API key, shared by every frontend app (web-app, chatbot-app,
 * chatbot-embedded, chrome-extension).
 * Not in .env because it is the same in every environment and carries no secret.
 */
export const TGGL_CLIENT_API_KEY = "AQLtdxxn_X4uv-Lww9Fj1b9zkNz0imB6QhHA6S2eRQs";
